module.exports = __webpack_public_path__ + "static/img/img-card-crm-bigbike-v1.cd0da72.png";